import React from 'react';

import PaymentsScene from '../../../PublicDashboard/screens/Payments';

function ExternalPayments() {
  return <PaymentsScene isPrivate />;
}

export default ExternalPayments;
